import * as React from "react";
// Controls
import { AnnounceProvider, Button, MessageBar, MessageBarActions, MessageBarBody } from "@fluentui/react-components";
import { Dismiss } from "@ms/planner-generic-controls/lib/local/icons";
import { SecureLink } from "@ms/planner-generic-controls/lib/local/secureLink/SecureLink";
import { usePlanCalendarNudgeStyles } from "./PlanCalendarNudge.styles";
// Constants
import { LearnMoreLinks } from "@ms/uno-constants/lib/local/AppConstants";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
const SilentAnnounceContextValue = {
    announce: ()=>undefined
};
/**
 * Message bar nudging users to update the plan's default time zone.
 */ export const PlanCalendarNudge = ({ message, updateButtonText, openSettingsButtonText, dismissButtonAriaLabel, onShown, onUpdate, onOpenPlanSettings, onDismiss })=>{
    const styles = usePlanCalendarNudgeStyles();
    // Fire the "shown" callback once per impression (the component only mounts when the nudge is visible).
    const onShownRef = React.useRef(onShown);
    onShownRef.current = onShown;
    React.useEffect(()=>{
        onShownRef.current?.();
    }, []);
    return(// Prevent Fluent's MessageBar from announcing this persistent nudge on mount.
    /*#__PURE__*/ React.createElement(AnnounceProvider, {
        value: SilentAnnounceContextValue
    }, /*#__PURE__*/ React.createElement(MessageBar, {
        "data-testid": "plan-calendar-nudge",
        role: "group",
        intent: "info",
        layout: "auto",
        className: styles.root,
        // Replace Fluent's dangling title reference because no MessageBarTitle is rendered.
        "aria-label": message,
        "aria-labelledby": undefined
    }, /*#__PURE__*/ React.createElement(MessageBarBody, {
        className: styles.body
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.messageText
    }, message), " ", /*#__PURE__*/ React.createElement(SecureLink, {
        href: LearnMoreLinks.planCalendarSettings
    }, Strings.PlanCalendar_LearnMoreLink)), /*#__PURE__*/ React.createElement(MessageBarActions, {
        className: styles.actions,
        containerAction: /*#__PURE__*/ React.createElement(Button, {
            "data-testid": "plan-calendar-nudge-button-dismiss",
            appearance: "transparent",
            icon: /*#__PURE__*/ React.createElement(Dismiss, null),
            onClick: onDismiss,
            "aria-label": dismissButtonAriaLabel
        })
    }, /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "plan-calendar-nudge-button-update",
        appearance: "primary",
        onClick: onUpdate
    }, updateButtonText), /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "plan-calendar-nudge-button-open-settings",
        onClick: (ev)=>onOpenPlanSettings(ev.currentTarget)
    }, openSettingsButtonText)))));
};
